import { h } from 'preact'
import './index.sass'

export default function APortalTheme({ children }){
  return <span className="APortalTheme">
    {children}
  </span>
}
